import styled, { css } from "styled-components";
import { UnStyledLink } from "../../../components/textButton";

export const CircleButtonWithContent = styled(UnStyledLink)(({ theme }) => css`
  border-radius: 50%;
  background-color: ${props => theme.palette.status[`${props.variant}`]};
  width: 200px;
  height: 200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border: rgba(0, 0, 0, 0);
  &:focus-within {
    outline: 1px dotted #111111;
  }

  svg {
    padding-bottom: 8px;
  }

  span {
    font-size: 15px;
    font-weight: ${theme.fonts.headingWeight};
    color: white;
    text-transform: ${theme.fonts.headingCase};
  }
`);